riot.tag2('bbc-notifications-add-topics', '<div class="notifications__container"> <header id="notifications__header" class="notifications__header notifications__header--js "> <h2 class="notifications-double-pica notification-title-variant">Start adding to get notifications</h2> </header> <p class="notifications-long-primer notifications--carousel-description">Here are some suggestions for things you can add from BBC Music and iPlayer.</p> <bbc-notifications-card-carousel cards="{this.suggestions}" base-path="{this.parent.basePath}"> <div class="notifications--card-carousel-row {refreshing ? \' notifications--card-carousel-row-refreshing\' : \'\'}"> <div class="notifications--card" each="{opts.cards}"> <a href="{link}"><div class="notifications--card-img" riot-style="background-image:url({image});"></div></a> <div class="notifications--card-body"> <a href="{link}"><p class="notifications-pica-bold">{title}</p></a> <p class="notifications-brevier">{product + (category ? \' | \' + category : \'\')}</p> </div> <div class="{\'notifications--card-actions\': true, \'notifications--card-actions-is-loading\': loading}"> <span class="notifications--card-actions-loading"> <span class="notifications--card-actions-loading-icon"></span><span class="notifications--card-actions-loading-label">{added ? \'Removing\' : \'Adding\'}</span> </span> <button class="{\'notifications--card-action-added\': added}" onclick="{parent.parent.toggleItem}"> <span class="notifications--card-action-remove"> <span class="notifications--card-action-icon"></span><span class="notifications--card-action-label">Remove</span> </span> <span class="notifications--card-action-add"> <span class="notifications--card-action-icon"></span><span class="notifications--card-action-label">{added ? \'Added\' : \'Add\'} to {parent.parent.productAreas[product]}</span> </span> </button> </div> <div if="{followError}" class="notifications--popup-error"> <button class="notifications--popup-close" onclick="{parent.parent.dismissFollowError}"><img riot-src="{parent.opts.basePath + \'/svg/close_icon_black.svg\'}"></button> <p class="notifications-great-primer">Something\'s gone wrong.</p> <p class="notifications-long-primer">Please try again later.</p> <div class="notifications--popup__arrow"></div> </div> </div> </div> </bbc-notifications-card-carousel> <div class="notifications--add-topics-footer"> <button class="notifications--refresh-btn notifications-long-primer" onclick="{this.refreshSuggestions}"><img class="notifications--refresh-btn-icon" riot-src="{this.parent.basePath + \'/svg/refresh.svg\'}">Show more suggestions</button> <button class="notifications--done-btn notifications-long-primer" __disabled="{!this.adds.length}" onclick="{this.done}">Done</button> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var uasClientLibrary = require('../uas');
var notificationsAnalytics = require('../analytics');
var suggestions = require('../models/suggestions');

this.done = function () {
    notificationsAnalytics.log('complete', 'notifications-in-tray-brand');
    _this.parent.parent.updateSubscriptionCount(_this.adds.length);
};

this.productAreas = {
    iPlayer: 'My Programmes',
    Music: 'My Music'
};

this.suggestions = suggestions.load();

this.refreshSuggestions = function () {
    _this.update({
        refreshing: true
    });

    setTimeout(function () {
        _this.update({
            suggestions: suggestions.load(),
            refreshing: false
        });
    }, 250);
    notificationsAnalytics.log('refresh', 'notifications-in-tray-brand');
};

this.adds = this.suggestions.filter(function (item) {
    return item.added;
});

this.addItem = function (e) {
    console.log('Adding', e.item);
    e.item.loading = true;
    _this.adds = _this.suggestions.filter(function (item) {
        return item.added;
    });
    _this.update();

    uasClientLibrary.addEvent(e.item, 'followed').then(function () {
        e.item.added = true;
        e.item.loading = false;
        e.item.followError = false;
        _this.adds = _this.suggestions.filter(function (item) {
            return item.added;
        });
        _this.update();
        notificationsAnalytics.log('add', 'notifications-in-tray-brand', {
            notifications_card_product: e.item.product,
            notifications_card_title: e.item.title,
            notifications_card_position: _this.suggestions.indexOf(e.item)
        });
    }).catch(function () {
        console.log('Failed to add item');
        _this.failToUpdateItem(e);
    });
};

this.failToUpdateItem = function (e) {
    e.item.loading = false;
    _this.adds = _this.suggestions.filter(function (item) {
        return item.added;
    });
    e.item.followError = true;
    _this.update();
};

this.removeItem = function (e) {
    console.log('Removing', e.item);
    e.item.loading = true;
    _this.adds = _this.suggestions.filter(function (item) {
        return item.added;
    });
    _this.update();

    uasClientLibrary.addEvent(e.item, 'unfollowed').then(function () {
        e.item.added = false;
        e.item.loading = false;
        _this.adds = _this.suggestions.filter(function (item) {
            return item.added;
        });
        e.item.followError = false;
        _this.update();
    }).catch(function () {
        _this.failToUpdateItem(e);
    });
};

this.toggleItem = function (e) {
    if (e.item.added) {
        _this.removeItem(e);
    } else {
        _this.addItem(e);
    }
};

this.dismissFollowError = function (e) {
    e.item.followError = false;
};
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-add-topics.tag
 ** module id = 17
 ** module chunks = 0
 **/